module.exports = __webpack_public_path__ + "img/more.94af4dfb.svg";